import { instructions } from "../../constants/instructions";
import { useInstructionsContext } from "../../contexts/InstructionsContext";
import { InstructionsCard } from "../templates/InstructionsCard";

export const Instructions = () => {
  const {
    currentStep,
    setStep,
    nextStep,
    onMinify,
    isMinified,
    isCompleted
  } = useInstructionsContext();

  return (
    <InstructionsCard
    instructions={instructions}
    currentStep={currentStep}
    nextStep={nextStep}
    setStep={setStep}
    onMinify={onMinify}
    isMinified={isMinified}
    isCompleted={isCompleted}
    />
  );
};
